type Props = {
  label?: string
  name: string
  error?: boolean
  invertColors?: boolean
}

const Input = ({label, name, error, invertColors}: Props) => (
  <input
    id={name}
    name={name}
    placeholder={label}
    className={`w-full appearance-none rounded-none border-b-[0.5px] py-3 outline-none text-headline-sm ${invertColors ? 'border-white bg-black text-white placeholder:text-white placeholder-shown:border-white-low' : 'border-black placeholder:text-black placeholder-shown:border-black-low'} focus:!outline-none focus-visible:!outline-none ${error ? '!border-red' : ''}`}
  />
)

export default Input
